export const maqueta = {
    text1: "Have been made",
    text2: "Check-ins",
    text3: "Sheets of paper saved 😊",
    text4: "Every 100 check-ins we plant a tree with",
    text5: "ONE TREE PLANTED",
    text6: "Notifications",
    text7: "You have no notifications",
    text8: "View all",
    text9: "Welcome",
    text10: "Company",
    text11: "All accommodations",
    text12: "Profile",
    text13: "Log out",
    text14: "Sorry, an error occurred while logging out",
    text15: "Your subscription payment was declined",
    text16: "To continue using WACheckin you must complete your payment",
    text17: "Check-in information",
    text18: "Check-in data",
    text19: "Request date:",
    text20: " at",
    text21: "Data collected during guest check-in",
    text22: "First name",
    text23: "Last name",
    text24: "Phone",
    text25: "Stay date",
    text26: "Document type",
    text27: "Passport",
    text28: "National ID card",
    text29: "Document number",
    text30: "Additional information",
    text31: "Document expiration",
    text32: "Nationality",
    text33: "Date of birth",
    text34: "Gender",
    text35: "Female",
    text36: "Male",
    text37: "Close",
    text38: "Check-ins",
    text39: "Service requests",
    text40: "Accommodations",
    text41: "Cross sales",
    text42: "Integrations",
    text43: "Billing",

    // Corrections
    p1: "Bookings",

    // Plan validation corrections
    p2: `Upgrade your plan to perform check-ins`,
    p3: `Sorry, you currently do not have any active subscription or credits for your accommodation.`,
    p4: `Upgrade plan`,

    p5: `Check-ins are not available in this accommodation.`,
    p6: `For more information, please contact the property owner.`,

    p7: `Account not verified`,
    p8: `Please check your inbox and confirm your account. Didn't receive the email?`,
    p9: `Resend`,
    p10: `Sending email, please wait...`,
    p11: `My subscription`,

    p12: `Language and region`,
    p13: `Choose a language and a region`,
    p14: `Here you can see all completed check-ins.`,
    p15: `Schedule your check-ins in advance and send them to your guests.`,
    p16: `Here you will find service requests from your guests, such as rentals, tours, and more.`,
    p17: `Mass WhatsApps`,
    p18: `Connect your WhatsApp Business account to our platform and enable mass sending of personalized messages to your guests quickly and easily, directly from your official number.`,
    p19: `This feature is still under development.`,
    p20: `Check-in information`,

    p21: `Check-in information`,
    p22: `Associated check-ins`,
    p23: `No associated check-ins.`,
    p24: `More information:`,
    p25: `Which accommodation would you like to manage?`,
    p26: ``,
    p27: ``,
    p28: ``,
    p29: ``,
    p30: ``,
    p31: ``,
};
